import { createConsola, LogLevels } from "consola";

function resolveLogLevel(): number {
	if (process.env.SPYGLASSES_DEBUG === "true") return LogLevels.debug;
	if (process.env.NODE_ENV === "development") return LogLevels.debug;
	if (process.env.INNGEST_DEV === "1") return LogLevels.debug;
	return LogLevels.warn;
}

export const logger = createConsola({
	level: resolveLogLevel(),
	formatOptions: {
		date: false,
	},
});
